import React from "react";
import MarketingLocationPage from "./MarketingLocationPage";

export default function OnlineMarketingGraz() {
  return <MarketingLocationPage locationKey="graz" />;
}
